import React from "react";

interface BrandLogoProps {
  expanded?: boolean;
  size?: "sm" | "md";
  inverse?: boolean;
}

/** Logo JULIA : pastille marine + J turquoise (aligné favicon RH). */
const BrandLogo: React.FC<BrandLogoProps> = ({
  expanded = true,
  size = "md",
  inverse = false,
}) => {
  const boxSize = size === "sm" ? 36 : 40;
  const titleSize = size === "sm" ? "1rem" : "1.125rem";

  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        gap: expanded ? "0.625rem" : 0,
        justifyContent: expanded ? "flex-start" : "center",
        width: expanded ? "auto" : "100%",
      }}
    >
      <div
        style={{
          width: boxSize,
          height: boxSize,
          borderRadius: "50%",
          background: inverse ? "rgba(255,255,255,0.12)" : "#1B2A4A",
          border: "2px solid #3ECFC4",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "#3ECFC4",
          fontWeight: 800,
          fontSize: size === "sm" ? "1rem" : "1.125rem",
          flexShrink: 0,
          fontFamily: "Georgia, 'Times New Roman', serif",
        }}
      >
        J
      </div>
      {expanded && (
        <span
          style={{
            fontWeight: 700,
            fontSize: titleSize,
            letterSpacing: "-0.02em",
            color: inverse ? "#fff" : "#1B2A4A",
            whiteSpace: "nowrap",
          }}
        >
          JU&apos;LIA{" "}
          <span
            style={{
              color: "#3ECFC4",
              fontWeight: 600,
              fontSize: size === "sm" ? "0.75rem" : "0.8125rem",
            }}
          >
            IA
          </span>
        </span>
      )}
    </div>
  );
};

export default BrandLogo;
